import type { HeaderFooterContentProps } from '@/components/page-sections/types';

/**
 * Page header section types and variants.
 */

export enum HeaderVariant {
  NAV_LEFT = 'nav-left',
  NAV_CENTER = 'nav-center',
  NAV_RIGHT = 'nav-right',
  LOGO_CENTER = 'logo-center',
}

export type HeaderVariantType = (typeof HeaderVariant)[keyof typeof HeaderVariant];

export interface HeaderVariantProps extends HeaderFooterContentProps {
  settings: {
    stickyClass: string;
    paddingClass: string;
    spacingClass: string;
  };
}
